import { dpApiV2 } from "./apiV2";

export type GlobalSettings = {
  hermes_inbound_enabled: boolean;
  hermes_outbound_enabled: boolean;
  dhl_inbound_enabled: boolean;
  dhl_outbound_enabled: boolean;
}


const extendedApi = dpApiV2.injectEndpoints({
  endpoints: builder => ({
    getGlobalSettings: builder.query<GlobalSettings, void>({
      query: () => ({
        url: "global_settings/",
        responseHandler: async response => {
          if (response.ok) {
            const responseJson = await response.json();

            return responseJson;
          }
          // Just return the error data
          return await response.json();
        }
      }),
      providesTags: [ "GlobalSettings" ]
    }),
  }),
  overrideExisting: true
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGlobalSettingsQuery
} = extendedApi;
